import ParseExpression from './ParseExpression.js'
import ParseSentences from './ParseSentences.js'

function ParseSentenceRepeat (parser) {
    this.parser = parser
    this.scanner = parser.scanner
    this.pcode = parser.pcode
    this.stable = parser.stable
    this.SC = parser.config
    this.hintHelper = parser.hintHelper
}

ParseSentenceRepeat.prototype = {
    parse () {
        let expType
        let expToken
        let repeatStart
        let expectedToken
        let parseExpression = new ParseExpression(this.parser)
        let parseSentences = new ParseSentences(this.parser)

        this.parser.expect(this.SC.K_REPEAT)

        if (this.parser.compile) {
            repeatStart = this.pcode.instructionCount() + 1
        }

        parseSentences.parse()

        expectedToken = this.parser.expect(this.SC.K_UNTIL)
        if (this.hintHelper && expectedToken === false) {
            this.hintHelper.checkTokensForHints([this.SC.K_UNTIL])
        }

        expToken = this.scanner.next()

        expType = parseExpression.parse()

        if (!expType.isBool()) {
            this.parser.error(expToken, 'La expresión debe ser de tipo Logico.')
        }

        if (this.parser.compile) {
            this.pcode.branch(repeatStart, expToken)
        }
    }
}

export default ParseSentenceRepeat



// WEBPACK FOOTER //
// ./src/Core/Parser/Components/ParseSentenceRepeat.js